import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HourglassComponent } from '../hourglass.component';
import { HourglassService } from 'src/app/services/hourglass.service';

@Component({
  selector: 'app-tab-settings',
  templateUrl: './tab-settings.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class TabSettingsComponent implements OnInit {
  events: any[] = [];
  settingsForm = {
    userID: sessionStorage.getItem("wOSAuthUser"),
    userInfo: sessionStorage.getItem('wOSUser'),
    timeBillable: 1,
    timeEntryFormat:'startend',
    tasksActive: 1,
    meetingLength: 60,
    timeEntryAge: 7,
    taskListAge: 30
  }
  isAdmin = sessionStorage.getItem('wOSAdmin');
  constructor(
    public authService: AuthService,
    private hourglassService: HourglassService
  ) { }

  ngOnInit() {
    
    this.isAdmin = sessionStorage.getItem("wOSAdmin");
    const userSettingsJSON: any = sessionStorage.getItem("wOSUserPrefs");
    const test: any = JSON.parse(userSettingsJSON);
    
    this.settingsForm.timeEntryFormat = test.timeentry_format;
    this.settingsForm.timeBillable = test.timeentry_billable;
    this.settingsForm.tasksActive = test.task_active;
    this.settingsForm.meetingLength = test.meeting_length_minutes;
    this.settingsForm.timeEntryAge = test.timeentry_age;
    this.settingsForm.taskListAge = test.timeentry_task_age;

  }

  // saveUserSettings(): void {
  //   this.hourglassService.saveUserSettings(this.settingsForm).then(r => {
  //     sessionStorage.setItem("wOSUserPrefs", JSON.stringify(r[0]));
  //     this.ngOnInit();
  //   })  
  // }
}
